import React from 'react';
import { Checkbox, Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const PricesSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Prezzo')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Prezzo Retail')} name='price_retail'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Prezzo Outlet')} name='outlet_price'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Sconto % sul prezzo Retail')} name='discount'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={6}>
        <Form.Item
          label={t('Sconto % sul prezzo Outlet')}
          name='outlet_discount_price'
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Prezzo Finale')} name='final_price'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label={t('Prezzo nascosto')}
          name='hide_price'
          valuePropName={'checked'}
        >
          <Checkbox disabled={isView} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(PricesSection);
